const svgUri = (svg) => 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg);
function ghsSvg(code) {
  const diamond = `<path d="M50 4 L96 50 L50 96 L4 50 Z" fill="#fff" stroke="#d92828" stroke-width="7"/>`;
  const symbols = {
    GHS02: `<path d="M52 78c-15 0-26-10-26-24 0-11 7-19 15-27-1 10 4 15 9 18 2-13 10-23 18-30-1 13 7 20 10 29 6 18-5 34-26 34z" fill="#000"/><path d="M50 70c-7 0-12-5-12-12 0-5 3-9 7-13 0 5 3 8 6 10 1-7 5-12 9-16 0 7 4 11 5 16 3 8-2 15-15 15z" fill="#fff"/>`,
    GHS07: `<rect x="45" y="24" width="10" height="37" rx="5" fill="#000"/><circle cx="50" cy="72" r="6" fill="#000"/>`,
    GHS09: `<path d="M35 70h36" stroke="#000" stroke-width="4"/><path d="M43 67V28m0 12-14-11m14 17 14-15m-14 26-18 8" stroke="#000" stroke-width="4" fill="none" stroke-linecap="round"/><path d="M63 67c8-7 15-7 23-1-8 7-15 7-23 1zm23-1 7-5v10z" fill="#000"/><path d="M22 72c13 5 27 5 40 0" stroke="#000" stroke-width="3" fill="none"/>`,
    GHS08: `<circle cx="50" cy="30" r="9" fill="#000"/><path d="M35 78c2-22 5-34 15-34s13 12 15 34z" fill="#000"/><path d="M50 47l4 7 8-1-6 6 3 8-9-4-9 4 3-8-6-6 8 1z" fill="#fff"/>`,
  };
  return svgUri(`<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100">${diamond}${symbols[code] || ''}</svg>`);
}

// GHS02/05/07/08/09 use the real official artwork (see ghsAssets in the clp-i18n script); codes
// without a supplied file (GHS01/03/04/06 — not offered in the picker anyway, see buildGhs())
// still fall back to the hand-drawn placeholder.
const commons = (file) => I18N.ghsAssets[file] || ghsSvg({ 'GHS-pictogram-flamme.svg': 'GHS02', 'GHS-pictogram-exclam.svg': 'GHS07', 'GHS-pictogram-pollu.svg': 'GHS09', 'GHS-pictogram-silhouette.svg': 'GHS08' }[file] || 'GHS07');
const GHS_DEFAULTS = {
  GHS01: 'GHS-pictogram-explos.svg',
  GHS02: 'GHS-pictogram-flamme.svg',
  GHS03: 'GHS-pictogram-rondflam.svg',
  GHS04: 'GHS-pictogram-bottle.svg',
  GHS05: 'GHS-pictogram-acid.webp',
  GHS06: 'GHS-pictogram-skull.svg',
  GHS07: 'GHS-pictogram-exclam.svg',
  GHS08: 'GHS-pictogram-silhouette.svg',
  GHS09: 'GHS-pictogram-pollu.svg',
};

const EN_WIDE_ASPECT = 960 / 486;
const EN_MANDATORY_DEFAULT = [{ id: 'warning', warning: true }, { id: '01.01' }, { id: '01.02' }, { id: '01.03' }];
const EN_CONDITIONAL_DEFAULT = [{ id: '02.01' }, { id: '03.01', wide: true }];
// Fragrance waxes: a fixed set of three pictograms, all mandatory (no conditional/optional picks).
// 01.01 is the wide two-panel "ventilate after use" symbol, padded to the same EN_WIDE_ASPECT.
const WAX_MANDATORY_DEFAULT = [{ id: 'warning', warning: true }, { id: '02.01' }, { id: '01.01', wide: true }];
const EN_OPTIONAL_DEFAULT = [
  { id: '04.01' },
  { id: '04.02' },
  { id: '04.03' },
  { id: '04.04' },
  { id: '04.05' },
  { id: '04.06' },
  { id: '04.07' },
  { id: '04.08' },
  { id: '04.09' },
  { id: '04.10', wide: true },
  { id: '04.11' },
  { id: '05.01', wide: true },
  { id: '06.01', wide: true },
  { id: '07.01' },
  { id: '08.01' },
  { id: '09.01' },
];

const REQUIRED_FIELD_SECTIONS = {
  'clp-productId': 'clp-step1',
  'clp-mass': 'clp-step1',
  'clp-batch': 'clp-step1',
  'clp-company': 'clp-step4',
  'clp-address': 'clp-step4',
  'clp-phone': 'clp-step4',
};
const REQUIRED_FIELDS = Object.keys(REQUIRED_FIELD_SECTIONS);

const EXPORT_POSITION_MAP = [
  { id: 'clp-titleClassic', namedChildren: ['clp-pvProductId', 'clp-pvFragrance'] },
  { id: 'clp-massBlock', self: true },
  { id: 'clp-pvSignal', self: true },
  { id: 'clp-pvUfi', self: true },
  { id: 'clp-pvUseInfo', self: true },
  { id: 'clp-pvEnCaption', self: true },
  { id: 'clp-pvSds', namedChildren: ['clp-pvHazard', 'clp-pvSupplement'] },
  { id: 'clp-pvGhs', items: ':scope > img' },
  { id: 'clp-pvCompany', items: ':scope > div' },
  { id: 'clp-pvEn', items: ':scope > .enItem', within: ':scope > *' },
];

const I18N = (() => {
  const fallback = { ghsLabels: {}, ghsAssets: {}, en15494Labels: {}, en15494Hints: {}, en15494Assets: {}, waxLabels: {}, waxAssets: {}, enGroupLabels: {}, step3Titles: {}, checklist: {} };
  const el = document.getElementById('clp-i18n');
  if (!el) return fallback;
  try {
    return { ...fallback, ...JSON.parse(el.textContent) };
  } catch (err) {
    console.error('Generator CLP: nie udało się odczytać tłumaczeń.', err);
    return fallback;
  }
})();

function buildGhsItems() {
  const items = {};
  Object.keys(GHS_DEFAULTS).forEach((code) => {
    items[code] = { code, label: I18N.ghsLabels[code] || code, file: GHS_DEFAULTS[code] };
  });
  return items;
}
function buildEnGroups(type) {
  if (type === 'wax') {
    const waxItem = (base) => ({ ...base, label: I18N.waxLabels[base.id] || base.id, hint: '', src: I18N.waxAssets[base.id] || null });
    return { mandatory: WAX_MANDATORY_DEFAULT.map(waxItem), conditional: [], optional: [] };
  }
  const withText = (base) => ({ ...base, label: I18N.en15494Labels[base.id] || base.id, hint: I18N.en15494Hints[base.id] || '' });
  return {
    mandatory: EN_MANDATORY_DEFAULT.map(withText),
    conditional: EN_CONDITIONAL_DEFAULT.map(withText),
    optional: EN_OPTIONAL_DEFAULT.map(withText),
  };
}

function pictogramSrc(item) {
  if (item.src !== undefined) return item.src;
  if (item.id && item.file === undefined) return I18N.en15494Assets[item.id] || null;
  return commons(item.file);
}
function escapeHtml(s) {
  return String(s || '').replace(/[&<>"']/g, (m) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' }[m]));
}
function mmPx(mm, visualWidth, widthMm) {
  return (Number(mm) * visualWidth) / Number(widthMm);
}
function fitTextPx(text, desiredMm, visualWidth, widthMm, maxFraction) {
  const desired = mmPx(desiredMm, visualWidth, widthMm);
  if (!text) return desired;
  const est = Math.max(1, text.length) * desired * 0.56;
  const available = visualWidth * maxFraction;
  const factor = Math.min(1, available / Math.max(1, est));
  return Math.max(desired * 0.56, desired * factor);
}

const ARC_HALF_ANGLE_DEG = 58;

function arcRingPath(cx, cy, r, direction) {
  const rad = (ARC_HALF_ANGLE_DEG * Math.PI) / 180,
    dx = r * Math.sin(rad),
    dy = r * Math.cos(rad),
    y = direction === 'up' ? cy - dy : cy + dy,
    sweep = direction === 'up' ? 1 : 0;
  return `M ${(cx - dx).toFixed(3)} ${y.toFixed(3)} A ${r.toFixed(3)} ${r.toFixed(3)} 0 0 ${sweep} ${(cx + dx).toFixed(3)} ${y.toFixed(3)}`;
}

function shapeInnerFraction(shape) {
  return shape === 'square' ? 0.9 : 0.86;
}

function labelTrueRadius(shape) {
  return 50 / shapeInnerFraction(shape);
}

function arcRingLength(r) {
  return r * ((2 * ARC_HALF_ANGLE_DEG * Math.PI) / 180);
}

function mmToArcUnits(mm, widthMm, shape) {
  return (Number(mm) * 100) / (Number(widthMm) * shapeInnerFraction(shape));
}
function arcFitUnits(text, desiredMm, widthMm, maxFraction, shape) {
  return (fitTextPx(text, desiredMm, 1, widthMm, maxFraction) * 100) / shapeInnerFraction(shape);
}

function arcRingFitUnits(text, desiredUnits, ringLength, maxFraction) {
  if (!text) return desiredUnits;
  const est = Math.max(1, text.length) * desiredUnits * 0.56;
  const available = ringLength * maxFraction;
  const factor = Math.min(1, available / Math.max(1, est));
  return Math.max(desiredUnits * 0.56, desiredUnits * factor);
}
function nonCandleText() {
  return { info: I18N.nonCandleInfo || '', ph: I18N.nonCandlePlaceholder || '' };
}
async function imgUrlToDataUri(url) {
  const res = await fetch(url, { mode: 'cors' }),
    blob = await res.blob();
  return await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}
function downloadBlob(name, blob) {
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(a.href), 1500);
}
async function canvasToPdfBlob(canvas, wMm, hMm) {
  const jpgBlob = await new Promise((resolve, reject) => canvas.toBlob((b) => (b ? resolve(b) : reject(new Error('JPEG'))), 'image/jpeg', 0.96));
  const jpg = new Uint8Array(await jpgBlob.arrayBuffer()),
    enc = new TextEncoder(),
    parts = [],
    offsets = [0];
  let pos = 0;
  const pushText = (t) => {
    const b = enc.encode(t);
    parts.push(b);
    pos += b.length;
  };
  const pushBytes = (b) => {
    parts.push(b);
    pos += b.length;
  };
  const start = (n) => {
    offsets[n] = pos;
    pushText(`${n} 0 obj\n`);
  };
  const end = () => pushText(`endobj\n`);
  const wPt = (wMm * 72) / 25.4,
    hPt = (hMm * 72) / 25.4;
  pushText('%PDF-1.4\n%EasyCandle\n');
  start(1);
  pushText('<< /Type /Catalog /Pages 2 0 R >>\n');
  end();
  start(2);
  pushText('<< /Type /Pages /Kids [3 0 R] /Count 1 >>\n');
  end();
  start(3);
  pushText(`<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ${wPt.toFixed(3)} ${hPt.toFixed(3)}] /Resources << /XObject << /Im0 4 0 R >> >> /Contents 5 0 R >>\n`);
  end();
  start(4);
  pushText(`<< /Type /XObject /Subtype /Image /Width ${canvas.width} /Height ${canvas.height} /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ${jpg.length} >>\nstream\n`);
  pushBytes(jpg);
  pushText('\nendstream\n');
  end();
  const stream = `q\n${wPt.toFixed(3)} 0 0 ${hPt.toFixed(3)} 0 0 cm\n/Im0 Do\nQ\n`;
  start(5);
  pushText(`<< /Length ${enc.encode(stream).length} >>\nstream\n${stream}endstream\n`);
  end();
  const xref = pos;
  pushText('xref\n0 6\n0000000000 65535 f \n');
  for (let i = 1; i <= 5; i++) pushText(String(offsets[i]).padStart(10, '0') + ' 00000 n \n');
  pushText(`trailer\n<< /Size 6 /Root 1 0 R >>\nstartxref\n${xref}\n%%EOF`);
  return new Blob(parts, { type: 'application/pdf' });
}

if (!customElements.get('clp-label-generator')) {
  customElements.define(
    'clp-label-generator',
    class ClpLabelGenerator extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        if (this._initialized) return;
        this._initialized = true;

        this.$ = (id) => this.querySelector('#' + id);
        this.state = { unit: 'g', ghs: new Set(), enConditional: new Set(), enOptional: new Set(), size: 60, shape: 'circle', titleMode: 'classic', showRequiredErrors: false };

        this.buildGhs();
        this.buildEn();
        this.bindStaticEvents();
        this.update();
      }

      buildGhs() {
        const mainCodes = ['NONE', 'GHS02', 'GHS05', 'GHS07', 'GHS09', 'GHS08'];
        const items = buildGhsItems();
        const render = (code) => {
          if (code === 'NONE')
            return `<label class="choice-card none-card ${this.state.ghs.size === 0 ? 'selected' : ''}"><input type="checkbox" data-ghs="NONE" ${this.state.ghs.size === 0 ? 'checked' : ''}>${I18N.ghsNone || ''}</label>`;
          const item = items[code];
          return `<label class="choice-card ${this.state.ghs.has(code) ? 'selected' : ''}" title="${item.label}"><input type="checkbox" data-ghs="${code}" ${this.state.ghs.has(code) ? 'checked' : ''}><img crossorigin="anonymous" src="${pictogramSrc(item)}" alt="${code} — ${item.label}"><span class="code">${code}</span></label>`;
        };
        this.$('clp-ghsMain').innerHTML = mainCodes.map(render).join('');
        this.querySelectorAll('[data-ghs]').forEach((el) =>
          el.addEventListener('change', (e) => {
            const code = e.target.dataset.ghs;
            if (code === 'NONE') this.state.ghs.clear();
            else e.target.checked ? this.state.ghs.add(code) : this.state.ghs.delete(code);
            this.buildGhs();
            this.update();
          })
        );
      }

      enCard(item, mode) {
        const locked = mode === 'mandatory';
        const set = mode === 'conditional' ? this.state.enConditional : this.state.enOptional;
        const checked = locked || set.has(item.id);
        const icon = `<img crossorigin="anonymous" class="${item.warning ? 'pictoWarn' : ''}" src="${pictogramSrc(item)}" alt="${escapeHtml(item.label)}">`;
        return `<label class="en-card ${locked ? 'locked' : ''} ${checked ? 'checked' : ''}" title="${escapeHtml(item.label)}"><input type="checkbox" data-en="${item.id}" data-mode="${mode}" ${checked ? 'checked' : ''} ${locked ? 'disabled' : ''}>${icon}${item.warning ? '' : `<span>${item.hint ? `<b>${escapeHtml(item.hint)}</b><br>` : ''}${escapeHtml(item.label)}</span>`}</label>`;
      }

      buildEn() {
        const type = this.$('clp-productType').value;
        const groups = buildEnGroups(type);
        const section = (label, cards) =>
          cards.length ? `<div class="en-group"><div class="en-group-title">${escapeHtml(label)}</div><div class="en-list">${cards.join('')}</div></div>` : '';
        this.$('clp-enSectionTitle').textContent = (type === 'wax' ? I18N.step3Titles.wax : I18N.step3Titles.candle) || '';
        this.$('clp-enAll').innerHTML =
          section(type === 'wax' ? I18N.enGroupLabels.waxMandatory : I18N.enGroupLabels.mandatory, groups.mandatory.map((x) => this.enCard(x, 'mandatory'))) +
          section(I18N.enGroupLabels.conditional, groups.conditional.map((x) => this.enCard(x, 'conditional'))) +
          section(I18N.enGroupLabels.optional, groups.optional.map((x) => this.enCard(x, 'optional')));
        this.querySelectorAll('[data-en]:not(:disabled)').forEach((el) =>
          el.addEventListener('change', (e) => {
            const set = e.target.dataset.mode === 'conditional' ? this.state.enConditional : this.state.enOptional;
            e.target.checked ? set.add(e.target.dataset.en) : set.delete(e.target.dataset.en);
            this.buildEn();
            this.update();
          })
        );
      }

      getShape() {
        return this.querySelector('input[name="clp-shapeMode"]:checked')?.value || 'circle';
      }
      getTitleMode() {
        return this.querySelector('input[name="clp-titleMode"]:checked')?.value || 'classic';
      }
      getCompanyMode() {
        return this.querySelector('input[name="clp-companyMode"]:checked')?.value || 'classic';
      }
      getGhsLayout() {
        return this.querySelector('input[name="clp-ghsLayout"]:checked')?.value || 'row';
      }
      getGhsWrap() {
        return this.querySelector('input[name="clp-ghsWrap"]:checked')?.value || 'none';
      }
      // Product types that carry a fixed pictogram block in step 3 (candles: EN 15494, waxes: their own set).
      hasPictoSection() {
        return ['candle', 'wax'].includes(this.$('clp-productType').value);
      }
      selectedEn() {
        const type = this.$('clp-productType').value;
        if (!this.hasPictoSection()) return [];
        const groups = buildEnGroups(type);
        const out = [...groups.mandatory];
        groups.conditional.forEach((i) => {
          if (this.state.enConditional.has(i.id)) out.push(i);
        });
        groups.optional.forEach((i) => {
          if (this.state.enOptional.has(i.id)) out.push(i);
        });
        return out;
      }

      getLabelDims() {
        const s = Number(this.$('clp-diameter').value);
        return { w: s, h: s, name: this.state.shape === 'circle' ? `Ø${s}mm` : `${s}x${s}mm` };
      }

      getExportDims() {
        const dims = this.getLabelDims();
        const bleed = 2;
        return { w: dims.w, h: dims.h, bw: dims.w + bleed * 2, bh: dims.h + bleed * 2, bleed, name: dims.name };
      }

      isAnyCoreData() {
        const filled = ['clp-productId', 'clp-fragrance', 'clp-mass', 'clp-batch', 'clp-hazardText', 'clp-supplementText', 'clp-ufi', 'clp-company', 'clp-address', 'clp-phone', 'clp-email', 'clp-www', 'clp-useInfo'].some((id) =>
          this.$(id).value.trim()
        );
        return filled || this.state.ghs.size > 0 || this.state.enConditional.size > 0 || this.state.enOptional.size > 0 || !!this.getSignal();
      }

      getSignal() {
        return this.querySelector('input[name="clp-signal"]:checked')?.value || '';
      }

      update() {
        this.state.shape = this.getShape();
        this.state.titleMode = this.getTitleMode();
        this.state.unit = this.$('clp-unit').value;
        const type = this.$('clp-productType').value;
        const candle = this.hasPictoSection();
        if (this.state.enType !== type) {
          this.state.enType = type;
          this.buildEn();
        }
        this.$('clp-enSection').classList.toggle('visible', candle);
        this.$('clp-nonCandleSection').classList.toggle('visible', !candle);
        if (!candle) {
          const t = nonCandleText();
          this.$('clp-nonCandleInfo').textContent = t.info;
          this.$('clp-useInfo').placeholder = t.ph;
        }

        this.$('clp-emptyHint').style.display = this.isAnyCoreData() ? 'none' : 'flex';
        const productId = this.$('clp-productId').value.trim();
        const fragrance = this.$('clp-fragrance').value.trim();
        this.$('clp-pvProductId').textContent = productId;
        this.$('clp-pvFragrance').textContent = fragrance;
        const arc1 = this.$('clp-arcText1').querySelector('textPath'),
          arc2 = this.$('clp-arcText2').querySelector('textPath');
        arc1.textContent = productId.toUpperCase();
        arc2.textContent = fragrance;

        const capArcTextLength = (tp, maxLen) => {
          if (!tp.textContent) return;
          if (tp.getComputedTextLength() > maxLen) {
            tp.setAttribute('textLength', maxLen);
            tp.setAttribute('lengthAdjust', 'spacingAndGlyphs');
          } else {
            tp.removeAttribute('textLength');
            tp.removeAttribute('lengthAdjust');
          }
        };

        const trueR = labelTrueRadius(this.state.shape);

        if (this.state.shape === 'square' && Number(this.$('clp-diameter').value) > 60) {
          this.$('clp-diameter').value = 60;
        }
        this.$('clp-sizeBtnsCircle').classList.toggle('visible', this.state.shape === 'circle');
        this.$('clp-sizeBtnsSquare').classList.toggle('visible', this.state.shape === 'square');

        const d = Number(this.$('clp-diameter').value);
        this.state.size = d;
        this.$('clp-diameterVal').textContent = d;
        this.querySelectorAll('[data-size-btn]').forEach((btn) => btn.classList.toggle('active', Number(btn.dataset.sizeBtn) === d));
        const dims = this.getLabelDims(),
          wMm = dims.w,
          hMm = dims.h;
        const visualW = Math.max(420, Math.min(650, 430 + (d - 40) * 5.5));
        const visualH = visualW;
        const label = this.$('clp-labelPreview');
        label.style.width = visualW + 'px';
        label.style.height = visualH + 'px';
        label.style.setProperty('--print-w', wMm + 'mm');
        label.style.setProperty('--print-h', hMm + 'mm');
        label.classList.toggle('square', this.state.shape === 'square');

        const bleedInset = mmPx(2, visualW, wMm);
        this.$('clp-cutGuide').setAttribute('viewBox', `0 0 ${visualW} ${visualH}`);
        this.$('clp-cutCircle').setAttribute('cx', visualW / 2);
        this.$('clp-cutCircle').setAttribute('cy', visualH / 2);
        this.$('clp-cutCircle').setAttribute('r', visualW / 2 - bleedInset);
        this.$('clp-cutRect').setAttribute('x', bleedInset);
        this.$('clp-cutRect').setAttribute('y', bleedInset);
        this.$('clp-cutRect').setAttribute('width', visualW - bleedInset * 2);
        this.$('clp-cutRect').setAttribute('height', visualH - bleedInset * 2);
        this.$('clp-diameterRow').style.opacity = '1';
        this.$('clp-diameter').disabled = false;
        this.$('clp-sizeSliderLabel').textContent = this.state.shape === 'circle' ? I18N.diameterLabel : I18N.sideLabel;
        const companySize = Number(this.$('clp-companySize').value);
        const titleSize = Number(this.$('clp-titleSize').value);

        const titleArc1Units = arcFitUnits(productId, titleSize * 0.7, wMm, 0.72, this.state.shape);
        const titleArc2Units = arcFitUnits(fragrance, titleSize, wMm, 0.68, this.state.shape);
        const titleStep = Math.max(titleArc1Units, titleArc2Units) * 1.15;
        const titleR1 = trueR - 6,
          titleR2 = titleR1 - titleStep;
        this.$('clp-titleArc1').setAttribute('d', arcRingPath(50, 50, titleR1, 'up'));
        this.$('clp-titleArc2').setAttribute('d', arcRingPath(50, 50, titleR2, 'up'));
        this.$('clp-titleClassic').style.visibility = this.state.titleMode === 'classic' ? 'visible' : 'hidden';
        this.$('clp-arcTitle').style.display = this.state.titleMode === 'arc' ? 'block' : 'none';

        const mass = this.$('clp-mass').value.trim();
        this.$('clp-pvMass').textContent = mass ? `${mass} ${this.state.unit}` : '';
        const batch = this.$('clp-batch').value.trim();
        this.$('clp-pvBatch').textContent = batch;
        this.$('clp-pvBatchWrap').style.display = batch ? 'inline' : 'none';
        this.$('clp-massBlock').style.display = mass || batch ? 'block' : 'none';

        this.$('clp-pvSignal').textContent = this.getSignal();
        const ghsWrap = this.getGhsWrap();
        const ghsFloats = { left: this.$('clp-pvGhsFloatL'), right: this.$('clp-pvGhsFloatR') };
        this.$('clp-pvGhs').innerHTML = '';
        ghsFloats.left.innerHTML = '';
        ghsFloats.right.innerHTML = '';
        [this.$('clp-pvGhs'), ghsFloats.left, ghsFloats.right].forEach((el) => el.classList.toggle('vertical', this.getGhsLayout() === 'column'));
        const ghsItems = buildGhsItems();
        const ghsCodes = [...this.state.ghs];
        // Wrap mode: the pictograms move out of their own row into floats inside the SDS block, so the
        // H/P text flows around them. "both" splits them — first half left, rest right.
        const leftCount = ghsWrap === 'both' ? Math.ceil(ghsCodes.length / 2) : ghsCodes.length;
        ghsCodes.forEach((code, i) => {
          const item = ghsItems[code];
          const img = document.createElement('img');
          img.crossOrigin = 'anonymous';
          img.src = pictogramSrc(item);
          img.alt = `${code} — ${item.label}`;
          const target = ghsWrap === 'none' ? this.$('clp-pvGhs') : ghsWrap === 'right' || (ghsWrap === 'both' && i >= leftCount) ? ghsFloats.right : ghsFloats.left;
          target.appendChild(img);
        });
        this.$('clp-pvGhs').style.display = ghsWrap === 'none' ? '' : 'none';
        this.$('clp-pvSds').classList.toggle('wrapGhs', ghsWrap !== 'none');
        this.querySelectorAll('[data-ghs-free-pos]').forEach((row) => (row.style.display = ghsWrap === 'none' ? '' : 'none'));

        this.$('clp-pvHazard').textContent = this.$('clp-hazardText').value.trim();
        this.$('clp-pvSupplement').textContent = this.$('clp-supplementText').value.trim();
        this.$('clp-pvUfi').textContent = this.$('clp-ufi').value.trim() ? `UFI: ${this.$('clp-ufi').value.trim()}` : '';

        this.$('clp-pvEn').innerHTML = '';
        this.$('clp-pvEnCaption').innerHTML = '';
        this.$('clp-pvUseInfo').textContent = '';
        if (candle) {
          const showText = this.$('clp-enTextToggle').checked;
          const selected = this.selectedEn();
          if (showText) {
            // The general warning triangle has no statement of its own, so it gets no caption line;
            // hints stay plain (not bold) so the whole caption reads as one uniform block.
            this.$('clp-pvEnCaption').innerHTML = selected
              .filter((item) => !item.warning)
              .map((item) => escapeHtml(item.hint ? `${item.hint}: ${item.label}` : item.label))
              .join('<br>');
          }
          this.$('clp-pvEnCaption').style.display = showText ? 'block' : 'none';
          selected.forEach((item) => {
            const itemEl = document.createElement('div');
            itemEl.className = 'enItem';
            const img = document.createElement('img');
            img.crossOrigin = 'anonymous';
            img.src = pictogramSrc(item);
            img.alt = item.label;
            if (item.warning) img.classList.add('pictoWarn');
            if (item.wide) img.dataset.wide = '1';
            itemEl.appendChild(img);
            this.$('clp-pvEn').appendChild(itemEl);
          });
          this.$('clp-pvEnBlock').style.display = 'flex';
          this.$('clp-pvUseInfo').style.display = 'none';
        } else {
          this.$('clp-pvEnBlock').style.display = 'none';
          this.$('clp-pvUseInfo').style.display = this.$('clp-useInfo').value.trim() ? 'block' : 'none';
          this.$('clp-pvUseInfo').textContent = this.$('clp-useInfo').value.trim();
        }

        const company = this.$('clp-company').value.trim(),
          address = this.$('clp-address').value.trim(),
          phone = this.$('clp-phone').value.trim(),
          email = this.$('clp-email').value.trim(),
          www = this.$('clp-www').value.trim();
        const contactPlain = [phone, email].filter(Boolean).join(' | ');
        const companyMode = this.getCompanyMode();
        
        const companyDesiredUnits = mmToArcUnits(companySize * 1.15, wMm, this.state.shape);
        const companyStep = companyDesiredUnits * 1.15;
        const companyR = {
          Www: trueR - 4,
          Contact: trueR - 4 - companyStep,
          Address: trueR - 4 - companyStep * 2,
          Name: trueR - 4 - companyStep * 3,
        };
        Object.entries(companyR).forEach(([key, r]) => this.$('clp-companyArcPath' + key).setAttribute('d', arcRingPath(50, 50, r, 'down')));
        const ARC_LINES = [
          ['clp-companyArcTextName', company, companyR.Name],
          ['clp-companyArcTextAddress', address, companyR.Address],
          ['clp-companyArcTextContact', contactPlain, companyR.Contact],
          ['clp-companyArcTextWww', www, companyR.Www],
        ];
        if (companyMode === 'arc') {
          this.$('clp-pvCompany').innerHTML = '';
          this.$('clp-pvCompany').style.display = 'none';
          this.$('clp-companyArc').style.display = ARC_LINES.some(([, text]) => text) ? 'block' : 'none';
          ARC_LINES.forEach(([id, text]) => {
            this.$(id).querySelector('textPath').textContent = text;
            this.$(id).style.display = text ? '' : 'none';
          });
        } else {
          const companyLines = [];
          if (company) companyLines.push(`${escapeHtml(company)}`);
          if (address) companyLines.push(escapeHtml(address));
          const contactHtml = [phone, email].filter(Boolean).map(escapeHtml).join(' &nbsp;|&nbsp; ');
          if (contactHtml) companyLines.push(contactHtml);
          if (www) companyLines.push(escapeHtml(www));
        
          this.$('clp-pvCompany').innerHTML = companyLines.map((line) => `<div>${line}</div>`).join('');
          this.$('clp-pvCompany').style.display = companyLines.length ? 'block' : 'none';
          this.$('clp-companyArc').style.display = 'none';
          ARC_LINES.forEach(([id]) => (this.$(id).querySelector('textPath').textContent = ''));
        }
        this.$('clp-companyArc').style.setProperty('--company-arc-x', Number(this.$('clp-companyX').value) + 'px');
        this.$('clp-companyArc').style.setProperty('--company-arc-y', Number(this.$('clp-companyY').value) + 'px');

        const metaSize = Number(this.$('clp-metaSize').value),
          enSize = Number(this.$('clp-enSize').value),
          signalSize = Number(this.$('clp-signalSize').value),
          sdsSize = Number(this.$('clp-sdsSize').value),
          ufiSize = Number(this.$('clp-ufiSize').value),
          ghsSize = Number(this.$('clp-ghsSize').value);
        ['titleSize', 'metaSize', 'signalSize', 'ghsSize', 'sdsSize', 'ufiSize', 'companySize'].forEach((id) => (this.$('clp-' + id + 'Val').textContent = this.$('clp-' + id).value));
        ['titleY', 'metaY', 'metaX', 'signalY', 'signalX', 'ghsY', 'ghsX', 'sdsY', 'ufiY', 'ufiX', 'companyY', 'companyX'].forEach((id) => (this.$('clp-' + id + 'Val').textContent = this.$('clp-' + id).value));
        this.$('clp-pvProductId').style.fontSize = fitTextPx(productId, titleSize * 0.72, visualW, wMm, this.state.shape === 'square' ? 0.82 : 0.72) + 'px';
        this.$('clp-pvFragrance').style.fontSize = fitTextPx(fragrance, titleSize, visualW, wMm, this.state.shape === 'square' ? 0.86 : 0.75) + 'px';
        this.$('clp-arcText1').style.fontSize = titleArc1Units + 'px';
        this.$('clp-arcText2').style.fontSize = titleArc2Units + 'px';
        capArcTextLength(arc1, arcRingLength(titleR1) * 0.82);
        capArcTextLength(arc2, arcRingLength(titleR2) * 0.82);
        this.$('clp-titleClassic').style.setProperty('--title-y', this.$('clp-titleY').value + 'px');
        this.$('clp-arcTitle').style.setProperty('--title-y', this.$('clp-titleY').value + 'px');
        this.$('clp-massBlock').style.fontSize = mmPx(metaSize, visualW, wMm) + 'px';
        if (this.$('clp-massBlock').classList.contains('positioned')) {
          this.$('clp-massBlock').style.left = 50 + Number(this.$('clp-metaX').value) + '%';
          this.$('clp-massBlock').style.top = 50 + Number(this.$('clp-metaY').value) + '%';
        }
        this.$('clp-pvEnBlock').style.setProperty('--en-y', this.$('clp-enY').value + 'px');
        this.$('clp-pvUseInfo').style.setProperty('--en-y', this.$('clp-enY').value + 'px');
        const enSizePx = mmPx(enSize, visualW, wMm);
        this.querySelectorAll('#clp-pvEn img,#clp-pvEn .warnSvg').forEach((el) => {
          el.style.width = (el.dataset.wide ? enSizePx * EN_WIDE_ASPECT : enSizePx) + 'px';
          el.style.height = enSizePx + 'px';
        });
        this.$('clp-pvEnCaption').style.fontSize = mmPx(Math.max(1.05, enSize * 0.22), visualW, wMm) + 'px';
        this.$('clp-pvUseInfo').style.fontSize = mmPx(Math.max(1.15, enSize * 0.23), visualW, wMm) + 'px';
        this.$('clp-pvSignal').style.fontSize = mmPx(signalSize, visualW, wMm) + 'px';
        if (this.$('clp-pvSignal').classList.contains('positioned')) {
          this.$('clp-pvSignal').style.left = 50 + Number(this.$('clp-signalX').value) + '%';
          this.$('clp-pvSignal').style.top = 50 + Number(this.$('clp-signalY').value) + '%';
        }
        this.querySelectorAll('#clp-pvGhs img,#clp-pvSds .ghsFloat img').forEach((el) => {
          el.style.width = mmPx(ghsSize, visualW, wMm) + 'px';
          el.style.height = mmPx(ghsSize, visualW, wMm) + 'px';
        });
        if (this.$('clp-pvGhs').classList.contains('positioned')) {
          this.$('clp-pvGhs').style.left = 50 + Number(this.$('clp-ghsX').value) + '%';
          this.$('clp-pvGhs').style.top = 50 + Number(this.$('clp-ghsY').value) + '%';
        }
        this.$('clp-pvSds').style.fontSize = mmPx(sdsSize, visualW, wMm) + 'px';
        this.$('clp-pvSds').style.setProperty('--sds-y', this.$('clp-sdsY').value + 'px');
        this.$('clp-pvUfi').style.fontSize = mmPx(ufiSize, visualW, wMm) + 'px';
        if (this.$('clp-pvUfi').classList.contains('positioned')) {
          this.$('clp-pvUfi').style.left = 50 + Number(this.$('clp-ufiX').value) + '%';
          this.$('clp-pvUfi').style.top = 50 + Number(this.$('clp-ufiY').value) + '%';
        }
        this.$('clp-pvCompany').style.fontSize = mmPx(companySize, visualW, wMm) + 'px';

        const companyArcLinesMeta = [
          ['clp-companyArcTextName', company, companyR.Name, 0.62],
          ['clp-companyArcTextAddress', address, companyR.Address, 0.78],
          ['clp-companyArcTextContact', contactPlain, companyR.Contact, 0.78],
          ['clp-companyArcTextWww', www, companyR.Www, 0.78],
        ];
        const companyArcFontUnits = Math.min(
          companyDesiredUnits,
          ...companyArcLinesMeta.map(([, text, r, maxFraction]) => arcRingFitUnits(text, companyDesiredUnits, arcRingLength(r), maxFraction))
        );
        companyArcLinesMeta.forEach(([id, , r, maxFraction]) => {
          this.$(id).style.fontSize = companyArcFontUnits + 'px';
          capArcTextLength(this.$(id).querySelector('textPath'), arcRingLength(r) * maxFraction);
        });
        if (this.$('clp-pvCompany').classList.contains('positioned')) {
          this.$('clp-pvCompany').style.left = 50 + Number(this.$('clp-companyX').value) + '%';
          this.$('clp-pvCompany').style.top = 50 + Number(this.$('clp-companyY').value) + '%';
        }

        this.querySelectorAll('input[type=range]').forEach((el) => {
          const min = Number(el.min) || 0,
            max = Number(el.max) || 100,
            pct = max > min ? ((Number(el.value) - min) / (max - min)) * 100 : 0;
          el.style.setProperty('--range-progress', pct + '%');
        });

        this.applyRequiredHighlight();
      }

      getChecklist() {
        const type = this.$('clp-productType').value;
        const anySds = ['clp-hazardText', 'clp-supplementText'].some((id) => this.$(id).value.trim()) || [...this.querySelectorAll('[data-na]')].some((cb) => cb.checked);
        const c = I18N.checklist;
        const items = [
          { label: c.productId, ok: !!this.$('clp-productId').value.trim() },
          { label: c.company, ok: !!(this.$('clp-company').value.trim() && this.$('clp-address').value.trim() && this.$('clp-phone').value.trim()) },
          { label: c.mass, ok: !!this.$('clp-mass').value.trim() },
          { label: c.batch, ok: !!this.$('clp-batch').value.trim() },
          { label: c.sds, ok: anySds },
        ];
        if (type === 'candle') items.push({ label: c.en15494, ok: true });
        if (type === 'wax') items.push({ label: c.wax, ok: true });
        return items;
      }
      getMissingFields() {
        return this.getChecklist()
          .filter((i) => !i.ok)
          .map((i) => i.label);
      }

      getInvalidRequiredFields() {
        return REQUIRED_FIELDS.filter((id) => !this.$(id).value.trim());
      }

      applyRequiredHighlight() {
        const invalid = this.state.showRequiredErrors ? this.getInvalidRequiredFields() : [];
        REQUIRED_FIELDS.forEach((id) => this.$(id).classList.toggle('field-invalid', invalid.includes(id)));
        return invalid;
      }

      revealRequiredErrors() {
        this.state.showRequiredErrors = true;
        const invalid = this.applyRequiredHighlight();
        if (!invalid.length) return true;
        const sections = new Set(invalid.map((id) => REQUIRED_FIELD_SECTIONS[id]));
        sections.forEach((sectionId) => {
          const details = this.$(sectionId);
          if (details && !details.open) details.open = true;
        });
        const firstInvalid = this.$(invalid[0]);

        setTimeout(() => {
          firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
          firstInvalid.focus({ preventScroll: true });
        }, 300);
        return false;
      }

      handleNa(cb) {
        const target = this.$(cb.dataset.na);
        if (cb.checked) {
          target.dataset.originalPlaceholder = target.dataset.originalPlaceholder || target.placeholder;
          target.value = '';
          target.disabled = true;
          target.placeholder = I18N.notApplicable || '';
        } else {
          target.disabled = false;
          target.placeholder = target.dataset.originalPlaceholder || '';
        }
        this.update();
      }

      enableFreeDrag(elementId, xId, yId) {
        const el = this.$(elementId),
          surface = this.$('clp-labelPreview');
        let active = false;
        el.addEventListener('pointerdown', (e) => {
          if (!el.textContent.trim() && !el.querySelector('img,svg,.warnSvg')) return;
          if (!el.classList.contains('positioned')) {
            const r = surface.getBoundingClientRect(),
              er = el.getBoundingClientRect();
            const x = ((er.left + er.width / 2 - r.left) / Math.max(1, r.width)) * 100 - 50;
            const y = ((er.top + er.height / 2 - r.top) / Math.max(1, r.height)) * 100 - 50;
            this.$(xId).value = Math.max(-50, Math.min(50, Math.round(x)));
            this.$(yId).value = Math.max(-50, Math.min(50, Math.round(y)));
            el.classList.add('positioned');
            this.update();
          }
          active = true;
          el.classList.add('dragging');
          el.setPointerCapture(e.pointerId);
          e.preventDefault();
        });
        el.addEventListener('pointermove', (e) => {
          if (!active) return;
          const r = surface.getBoundingClientRect();
          const x = ((e.clientX - r.left) / Math.max(1, r.width)) * 100 - 50;
          const y = ((e.clientY - r.top) / Math.max(1, r.height)) * 100 - 50;
          this.$(xId).value = Math.max(-50, Math.min(50, Math.round(x)));
          this.$(yId).value = Math.max(-50, Math.min(50, Math.round(y)));
          this.update();
        });
        const stop = (e) => {
          if (!active) return;
          active = false;
          el.classList.remove('dragging');
          try {
            el.releasePointerCapture(e.pointerId);
          } catch (_) {}
        };
        el.addEventListener('pointerup', stop);
        el.addEventListener('pointercancel', stop);
      }

      enableFlowDragY(elementId, yId) {
        const el = this.$(elementId);
        let active = false,
          startClientY = 0,
          startVal = 0;
        el.addEventListener('pointerdown', (e) => {
          if (!el.textContent.trim() && !el.querySelector('img,svg,.warnSvg')) return;
          active = true;
          startClientY = e.clientY;
          startVal = Number(this.$(yId).value);
          el.classList.add('dragging');
          el.setPointerCapture(e.pointerId);
          e.preventDefault();
        });
        el.addEventListener('pointermove', (e) => {
          if (!active) return;
          const min = Number(this.$(yId).min),
            max = Number(this.$(yId).max);
          const next = Math.max(min, Math.min(max, Math.round(startVal + (e.clientY - startClientY))));
          this.$(yId).value = next;
          this.update();
        });
        const stop = (e) => {
          if (!active) return;
          active = false;
          el.classList.remove('dragging');
          try {
            el.releasePointerCapture(e.pointerId);
          } catch (_) {}
        };
        el.addEventListener('pointerup', stop);
        el.addEventListener('pointercancel', stop);
      }

      buildArcTspans(textPathEl, targetTextEl, fontSize) {
        while (targetTextEl.firstChild) targetTextEl.removeChild(targetTextEl.firstChild);
        const text = textPathEl.textContent || '';
        if (!text) return;
        const SVG_NS = 'http://www.w3.org/2000/svg';
        for (let i = 0; i < text.length; i++) {
          const pos = textPathEl.getStartPositionOfChar(i),
            rot = textPathEl.getRotationOfChar(i),
            tspan = document.createElementNS(SVG_NS, 'tspan');
          tspan.setAttribute('x', pos.x.toFixed(2));
          tspan.setAttribute('y', pos.y.toFixed(2));
          tspan.setAttribute('rotate', rot.toFixed(2));
          tspan.setAttribute('text-anchor', 'start');

          if (fontSize) tspan.setAttribute('font-size', fontSize);
          tspan.textContent = text[i];
          targetTextEl.appendChild(tspan);
        }
      }

      measureAndPositionBlocks(cloned, scale) {
        const ghsWrapped = this.getGhsWrap() !== 'none';
        const innerRect = this.$('clp-labelInner').getBoundingClientRect();
        const place = (liveEl, cloneEl) => {
          if (!liveEl || !cloneEl) return;
          if (getComputedStyle(liveEl).display === 'none') return;
          const r = liveEl.getBoundingClientRect();
          if (!r.width && !r.height) return;
          cloneEl.style.position = 'absolute';
          cloneEl.style.margin = '0';
          cloneEl.style.transform = 'none';
          cloneEl.style.left = ((r.left - innerRect.left) * scale).toFixed(4) + 'px';
          cloneEl.style.top = ((r.top - innerRect.top) * scale).toFixed(4) + 'px';
          cloneEl.style.width = (r.width * scale).toFixed(4) + 'px';
        };
        EXPORT_POSITION_MAP.forEach(({ id, self, namedChildren, items, within }) => {
          const liveEl = this.$(id),
            cloneEl = cloned.querySelector('#' + id);
          if (!liveEl || !cloneEl) return;
          // With GHS floats inside the SDS block, its text has to re-flow around them in the clone,
          // so the block is placed as a whole instead of pinning hazard/supplement separately.
          if (self || (ghsWrapped && id === 'clp-pvSds')) return place(liveEl, cloneEl);
          if (namedChildren) return namedChildren.forEach((cid) => place(this.$(cid), cloned.querySelector('#' + cid)));
          if (items) {
            const liveItems = [...liveEl.querySelectorAll(items)],
              cloneItems = [...cloneEl.querySelectorAll(items)];
            liveItems.forEach((liveItem, i) => {
              const cloneItem = cloneItems[i];
              if (!cloneItem) return;
              if (!within) return place(liveItem, cloneItem);
              const liveKids = [...liveItem.querySelectorAll(within)],
                cloneKids = [...cloneItem.querySelectorAll(within)];
              liveKids.forEach((k, j) => place(k, cloneKids[j]));
            });
          }
        });
      }
      async generateSvg() {
        const dims = this.getExportDims(),
          NATIVE_SCALE = 10,
          w = dims.w,
          h = dims.h,
          bw = dims.bw,
          bh = dims.bh,
          bleed = dims.bleed,
          cloned = this.$('clp-labelInner').cloneNode(true);
        cloned.querySelector('#clp-emptyHint')?.remove();
        const visual = parseFloat(this.$('clp-labelPreview').style.width) || 560,
          scale = (w * NATIVE_SCALE) / visual;
        this.measureAndPositionBlocks(cloned, scale);
        cloned.style.width = this.state.shape === 'square' ? '90%' : '86%';
        cloned.style.height = this.state.shape === 'square' ? '90%' : '86%';
        const radius = this.state.shape === 'square' ? '3%' : '50%';
        if (this.state.titleMode === 'arc') {
          ['clp-arcText1', 'clp-arcText2'].forEach((textId) => {
            const liveTextEl = this.$(textId),
              liveTextPath = liveTextEl?.querySelector('textPath'),
              clonedText = cloned.querySelector('#' + textId);
            if (liveTextPath && clonedText) this.buildArcTspans(liveTextPath, clonedText, liveTextEl.style.fontSize);
          });
        }
        if (this.getCompanyMode() === 'arc') {
          ['clp-companyArcTextName', 'clp-companyArcTextAddress', 'clp-companyArcTextContact', 'clp-companyArcTextWww'].forEach((textId) => {
            const liveTextEl = this.$(textId),
              liveTextPath = liveTextEl?.querySelector('textPath'),
              clonedText = cloned.querySelector('#' + textId);
            if (liveTextPath && liveTextPath.textContent && clonedText) this.buildArcTspans(liveTextPath, clonedText, liveTextEl.style.fontSize);
          });
        }
        await Promise.all(
          [...cloned.querySelectorAll('img')].map(async (img) => {
            const src = img.getAttribute('src');
            if (!src || src.startsWith('data:')) return;
            try {
              img.setAttribute('src', await imgUrlToDataUri(src));
            } catch (err) {
              console.error('CLP: could not inline pictogram for export', src, err);
            }
          })
        );
        // The export SVG is rendered as an image, which can't load the page's web fonts — embed the
        // theme body font (the one the preview uses) so the file matches the preview instead of falling
        // back to Arial.
        let fontFace = '';
        if (I18N.exportFont) {
          try {
            fontFace = `@font-face{font-family:ClpLabelFont;src:url(${await imgUrlToDataUri(I18N.exportFont)})}`;
          } catch (err) {
            console.error('CLP: could not inline label font for export', err);
          }
        }
        const clonedXml = new XMLSerializer().serializeToString(cloned);
        const w2 = w * NATIVE_SCALE,
          h2 = h * NATIVE_SCALE,
          bw2 = bw * NATIVE_SCALE,
          bh2 = bh * NATIVE_SCALE,
          bleed2 = bleed * NATIVE_SCALE;
        const wrapper = `<div xmlns="http://www.w3.org/1999/xhtml" style="width:${w2}px;height:${h2}px;background:#fff;color:#000;border-radius:${radius};display:flex;align-items:center;justify-content:center;overflow:hidden;font-family:${fontFace ? 'ClpLabelFont,' : ''}Arial,Helvetica,sans-serif;"><style>${fontFace}${this.getExportCss(scale, NATIVE_SCALE)}</style>${clonedXml}</div>`;
        const cut =
          this.state.shape === 'square'
            ? `<rect x="${bleed2 + 0.15 * NATIVE_SCALE}" y="${bleed2 + 0.15 * NATIVE_SCALE}" width="${w2 - 0.3 * NATIVE_SCALE}" height="${h2 - 0.3 * NATIVE_SCALE}" rx="${NATIVE_SCALE}" fill="none" stroke="#777" stroke-width="${0.15 * NATIVE_SCALE}" stroke-dasharray="${NATIVE_SCALE} ${NATIVE_SCALE}"/>`
            : `<circle cx="${bw2 / 2}" cy="${bh2 / 2}" r="${w2 / 2 - 0.2 * NATIVE_SCALE}" fill="none" stroke="#777" stroke-width="${0.15 * NATIVE_SCALE}" stroke-dasharray="${NATIVE_SCALE} ${NATIVE_SCALE}"/>`;
        const bg = this.state.shape === 'square' ? `<rect width="${bw2}" height="${bh2}" fill="#fff"/>` : `<circle cx="${bw2 / 2}" cy="${bh2 / 2}" r="${Math.max(bw2, bh2) / 2}" fill="#fff"/>`;
        return `<svg xmlns="http://www.w3.org/2000/svg" width="${bw}mm" height="${bh}mm" viewBox="0 0 ${bw2} ${bh2}">${bg}<foreignObject x="${bleed2}" y="${bleed2}" width="${w2}" height="${h2}">${wrapper}</foreignObject>${cut}</svg>`;
      }

      getExportCss(scale, nativeScale) {
        const px = (n) => (Number(n) * scale).toFixed(4) + 'px';
        const fontPx = (id) => px(parseFloat(this.$(id).style.fontSize) || 12);
        const mmUnits = (mm) => (Number(mm) * nativeScale).toFixed(4) + 'px';
        const rawFontSize = (id) => this.$(id).style.fontSize || '12px';
        const lineHeightPx = (id, mult) => (parseFloat(fontPx(id)) * mult).toFixed(4) + 'px';
        const ty = px(this.$('clp-titleY').value);
        const cax = px(this.$('clp-companyX').value);
        const cay = px(this.$('clp-companyY').value);
        return `
.labelInner{position:relative;color:#000;text-align:center}.labelInner *{color:#000;font-weight:400}.titleId{font-weight:400;text-transform:uppercase;line-height:${lineHeightPx('clp-pvProductId', 1.08)};font-size:${fontPx('clp-pvProductId')}!important}.titleFragrance{font-weight:400;line-height:${lineHeightPx('clp-pvFragrance', 1.05)};font-size:${fontPx('clp-pvFragrance')}!important}.arcTitle{position:absolute;inset:0;width:100%;height:100%;overflow:visible;transform:translateY(${ty});display:${this.state.titleMode === 'arc' ? 'block' : 'none'}}.arcTitle text{font-family:Arial,Helvetica,sans-serif;font-weight:400;fill:#000;text-anchor:middle}.arcTitle #clp-arcText1{font-size:${rawFontSize('clp-arcText1')}!important}.arcTitle #clp-arcText2{font-size:${rawFontSize('clp-arcText2')}!important}.massBlock{white-space:nowrap;font-size:${fontPx('clp-massBlock')}!important}.enItem img,.enItem .warnSvg{width:${mmUnits(this.$('clp-enSize').value)}!important;height:${mmUnits(this.$('clp-enSize').value)}!important}.enItem img[data-wide]{width:${mmUnits(Number(this.$('clp-enSize').value) * EN_WIDE_ASPECT)}!important}.enCaption{line-height:${(parseFloat(mmUnits(Math.max(1.05, Number(this.$('clp-enSize').value) * 0.22))) * 1.2).toFixed(4)}px;text-align:center;font-size:${mmUnits(Math.max(1.05, Number(this.$('clp-enSize').value) * 0.22))}!important}.signalBlock{font-weight:400;text-transform:uppercase;font-size:${fontPx('clp-pvSignal')}!important}.sdsBlock{line-height:${lineHeightPx('clp-pvSds', 1.24)};white-space:pre-line;text-align:center;font-size:${fontPx('clp-pvSds')}!important}.containsBlock{font-weight:400}.ghsBlock img,.ghsFloat img{width:${mmUnits(this.$('clp-ghsSize').value)}!important;height:${mmUnits(this.$('clp-ghsSize').value)}!important}.sdsBlock.wrapGhs{display:flow-root}.ghsFloat{display:none;gap:.25em;flex-wrap:wrap;margin-bottom:.2em}.ghsFloat.vertical{flex-direction:column}.wrapGhs .ghsFloat:not(:empty){display:flex}.ghsFloat--left{float:left;margin-right:.35em}.ghsFloat--right{float:right;margin-left:.35em}.ufiBlock{font-weight:400;font-size:${fontPx('clp-pvUfi')}!important}.useInfoBlock{line-height:${lineHeightPx('clp-pvUseInfo', 1.23)};white-space:pre-line;font-size:${fontPx('clp-pvUseInfo')}!important}.companyBlock{font-size:${fontPx('clp-pvCompany')}!important}.companyArc{position:absolute;inset:0;width:100%;height:100%;overflow:visible;transform:translate(${cax},${cay});display:${this.getCompanyMode() === 'arc' ? 'block' : 'none'}}.companyArc text{font-family:Arial,Helvetica,sans-serif;font-weight:400;fill:#000;text-anchor:middle}.companyArc text.arcName{font-weight:400}.companyArc #clp-companyArcTextName{font-size:${rawFontSize('clp-companyArcTextName')}!important}.companyArc #clp-companyArcTextAddress{font-size:${rawFontSize('clp-companyArcTextAddress')}!important}.companyArc #clp-companyArcTextContact{font-size:${rawFontSize('clp-companyArcTextContact')}!important}.companyArc #clp-companyArcTextWww{font-size:${rawFontSize('clp-companyArcTextWww')}!important}`;
      }

      waitForPreviewImages() {
        const imgs = [...this.querySelectorAll('#clp-labelInner img')];
        return Promise.all(
          imgs.map(
            (img) =>
              img.complete ||
              new Promise((resolve) => {
                img.addEventListener('load', resolve, { once: true });
                img.addEventListener('error', resolve, { once: true });
              })
          )
        );
      }
      confirmIncomplete() {
        const missing = this.getMissingFields();
        if (!missing.length) return true;
        const message = (I18N.confirmIncomplete || '').replace('{{ missing }}', missing.join(', '));
        return confirm(message);
      }
      async captureLabelCanvas() {
        await this.waitForPreviewImages();
        const dims = this.getExportDims(),
          svg = await this.generateSvg(),
          // A `blob:` URL taints the canvas once the SVG contains a <foreignObject> (Chromium bug 294129);
          // only a `data:` URI is guaranteed origin-clean across browsers for this technique.
          url = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg),
          img = new Image();
        await new Promise((resolve, reject) => {
          img.onload = resolve;
          img.onerror = reject;
          img.src = url;
        });
        const canvas = document.createElement('canvas');
        canvas.width = Math.round((dims.bw / 25.4) * 300);
        canvas.height = Math.round((dims.bh / 25.4) * 300);
        const ctx = canvas.getContext('2d');
        ctx.fillStyle = '#fff';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        return canvas;
      }
      async downloadPng() {
        if (!this.revealRequiredErrors()) return;
        if (!this.confirmIncomplete()) return;
        try {
          const dims = this.getExportDims(),
            canvas = await this.captureLabelCanvas();
          canvas.toBlob((blob) => {
            if (blob) downloadBlob(`EasyCandle_CLP_${dims.name}_300dpi.png`, blob);
          }, 'image/png');
        } catch (err) {
          console.error(err);
          alert(I18N.pngError || '');
        }
      }
      async downloadPdf() {
        if (!this.revealRequiredErrors()) return;
        if (!this.confirmIncomplete()) return;
        try {
          const dims = this.getExportDims(),
            canvas = await this.captureLabelCanvas(),
            blob = await canvasToPdfBlob(canvas, dims.bw, dims.bh);
          downloadBlob(`EasyCandle_CLP_${dims.name}.pdf`, blob);
        } catch (err) {
          console.error(err);
          alert(I18N.pdfError || '');
        }
      }
      // "Wyślij do druku" temporarily disabled — matching comment around clp-printBtn / clp-printModal
      // in clp-label-generator.liquid, and around the print-modal bindings in bindStaticEvents() below.
      // prepareOrder() {
      //   if (!this.confirmIncomplete()) return;
      //   const data = {
      //     productType: this.$('clp-productType').value,
      //     productId: this.$('clp-productId').value,
      //     fragrance: this.$('clp-fragrance').value,
      //     mass: this.$('clp-mass').value,
      //     unit: this.state.unit,
      //     batch: this.$('clp-batch').value,
      //     ufi: this.$('clp-ufi').value,
      //     format: this.state.shape === 'square' ? `${this.$('clp-diameter').value}x${this.$('clp-diameter').value} mm` : `Ø${this.$('clp-diameter').value} mm`,
      //     width_mm: this.getLabelDims().w,
      //     height_mm: this.getLabelDims().h,
      //     quantity: Number(this.$('clp-qty').value),
      //     material: this.$('clp-material').value,
      //     finish: this.$('clp-finish').value,
      //     note: this.$('clp-orderNote').value,
      //     customerDeclaration: true,
      //     createdAt: new Date().toISOString(),
      //   };
      //   downloadBlob('EasyCandle_zlecenie_wydruku.json', new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' }));
      //   this.$('clp-printModal').classList.remove('open');
      // }

      bindStaticEvents() {
        this.querySelectorAll('input[type=text],input[type=number],textarea,select').forEach((el) => {
          el.addEventListener('input', () => this.update());
          el.addEventListener('change', () => this.update());
        });
        this.querySelectorAll('[data-na]').forEach((cb) => cb.addEventListener('change', () => this.handleNa(cb)));
        this.querySelectorAll('input[name="clp-signal"],input[name="clp-shapeMode"],input[name="clp-titleMode"],input[name="clp-companyMode"],input[name="clp-ghsLayout"],input[name="clp-ghsWrap"]').forEach((el) =>
          el.addEventListener('change', () => this.update())
        );
        this.querySelectorAll('[data-size-btn]').forEach((btn) =>
          btn.addEventListener('click', () => {
            this.$('clp-diameter').value = btn.dataset.sizeBtn;
            this.update();
          })
        );
        this.$('clp-enTextToggle').addEventListener('change', () => this.update());
        ['diameter', 'titleSize', 'titleY', 'metaSize', 'metaY', 'metaX', 'enSize', 'enY', 'signalSize', 'signalY', 'signalX', 'ghsSize', 'ghsY', 'ghsX', 'sdsSize', 'sdsY', 'ufiSize', 'ufiY', 'ufiX', 'companySize', 'companyY', 'companyX'].forEach(
          (id) => this.$('clp-' + id).addEventListener('input', () => this.update())
        );
        ['metaX', 'metaY'].forEach((id) => this.$('clp-' + id).addEventListener('input', () => this.$('clp-massBlock').classList.add('positioned')));
        ['companyX', 'companyY'].forEach((id) => this.$('clp-' + id).addEventListener('input', () => this.$('clp-pvCompany').classList.add('positioned')));
        ['signalX', 'signalY'].forEach((id) => this.$('clp-' + id).addEventListener('input', () => this.$('clp-pvSignal').classList.add('positioned')));
        ['ghsX', 'ghsY'].forEach((id) => this.$('clp-' + id).addEventListener('input', () => this.$('clp-pvGhs').classList.add('positioned')));
        ['ufiX', 'ufiY'].forEach((id) => this.$('clp-' + id).addEventListener('input', () => this.$('clp-pvUfi').classList.add('positioned')));

        this.enableFreeDrag('clp-massBlock', 'clp-metaX', 'clp-metaY');
        this.enableFreeDrag('clp-pvCompany', 'clp-companyX', 'clp-companyY');
        // Signal word + GHS pictograms + UFI code used to be flow-Y-only (enableFlowDragY) — with a
        // long signal word, many GHS icons, or a long UFI code they can grow wide/tall enough to
        // collide with neighboring blocks, and flow-Y can't move them sideways out of the way, so
        // they get the same free 2D drag as mass/company instead.
        this.enableFreeDrag('clp-pvSignal', 'clp-signalX', 'clp-signalY');
        this.enableFreeDrag('clp-pvGhs', 'clp-ghsX', 'clp-ghsY');
        this.enableFreeDrag('clp-pvUfi', 'clp-ufiX', 'clp-ufiY');
        this.enableFlowDragY('clp-titleClassic', 'clp-titleY');
        this.enableFlowDragY('clp-arcTitle', 'clp-titleY');
        this.enableFlowDragY('clp-pvEnBlock', 'clp-enY');
        this.enableFlowDragY('clp-pvUseInfo', 'clp-enY');
        this.enableFlowDragY('clp-pvSds', 'clp-sdsY');

        this.$('clp-pngBtn').addEventListener('click', () => this.downloadPng());
        this.$('clp-pdfBtn').addEventListener('click', () => this.downloadPdf());

        // "Wyślij do druku" temporarily disabled — clp-printBtn/clp-printModal and friends are
        // commented out in clp-label-generator.liquid, so these elements no longer exist in the DOM.
        // const modal = this.$('clp-printModal');
        // this.$('clp-printBtn').addEventListener('click', () => modal.classList.add('open'));
        // this.$('clp-closeModal').addEventListener('click', () => modal.classList.remove('open'));
        // modal.addEventListener('click', (e) => {
        //   if (e.target === modal) modal.classList.remove('open');
        // });
        // this.$('clp-orderConsent').addEventListener('change', () => (this.$('clp-prepareOrder').disabled = !this.$('clp-orderConsent').checked));
        // this.$('clp-prepareOrder').addEventListener('click', () => this.prepareOrder());
      }
    }
  );
}
